import script from "./PageEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageEditor.vue?vue&type=script&lang=ts&setup=true"

import "./PageEditor.vue?vue&type=style&index=0&id=96703e44&lang=css"

const __exports__ = script;

export default __exports__